/* eslint-disable  no-useless-escape */
export const userValidation = {
  mandatory,
  mandatoryBackOffice,
  mandatoryProfileDetails,
  mandatoryMaptoolx,
  loginValidation,
  forgotPasswordValidation,
  ResetValidation
}

function mandatory(user) {
  const errors = {}
  if (!user.firstName) {
    errors.firstName = 'First Name is required'
  }
  if (!user.lastName) {
    errors.lastName = 'Last Name is required'
  }
  if (!user.emailAddress) {
    errors.emailAddress = 'Email Address is required'
  }
  if (!user.roleId > 0) {
    errors.role = 'Role is required'
  }
  return errors
}

function mandatoryBackOffice(backOffice) {
  const errors = {}
  if (!backOffice?.oldPassword) {
    errors.oldPassword = 'Old Password is required'
  }
  if (!backOffice?.newPassword) {
    errors.newPassword = 'New Password is required'
  }
  if (!backOffice?.confirmNewPassword) {
    errors.confirmNewPassword = 'Confirm New Password is required'
  }
  else if (backOffice?.newPassword !== backOffice?.confirmNewPassword) {
    errors.confirmNewPassword = 'Password and Confrim Password should match'}
    return errors
}
function loginValidation(userName,password){
  const errors={userName:'',password:''}
  if(!userName){
    errors.userName='Username is required'
  }
  if(!password){
    errors.password='Password is required'
  }  
  return errors
}

function ResetValidation(newpassword,cpassword){
  const errors={newpassword:'',cpassword:''}
  if(!newpassword){
    errors.newpassword='New Password is required'
  }
  if(!cpassword){
    errors.cpassword='Confirm New Password is required'

  }
    return errors
}

function mandatoryProfileDetails(profileDetails) {
  const errors = {}
  if (!profileDetails?.firstName) {
    errors.firstName = 'First Name is required'
  }
  if (!profileDetails?.lastName) {
    errors.lastName = 'Last Name is required'}
    return errors
  }
function forgotPasswordValidation(emailAddress){
  const errors={emailAddress:''}
  if(!emailAddress){
    errors.emailAddress='Emailaddress is required'
  }
  if(!ValidateEmail(emailAddress)){
    errors.emailAddress='Email Address is required'
  }
  return errors
}

function mandatoryMaptoolx(maptoolx) {
  const errors = {}

  if (!maptoolx?.maptoolxUserName) {
    errors.maptoolxUserName = 'User Name is required'
  }
  if (!maptoolx?.maptoolxOldPassword) {
    errors.maptoolxOldPassword = 'Old Password is required'
  }
  if (!maptoolx?.maptoolxNewPassword) {
    errors.maptoolxNewPassword = 'New Password is required'
  }
  if (!maptoolx?.maptoolxConfirmNewPassword) {
    errors.maptoolxConfirmNewPassword = 'Confirm New Password is required'
  }

  else if (maptoolx?.maptoolxNewPassword !== maptoolx?.maptoolxConfirmNewPassword) {
    errors.maptoolxConfirmNewPassword = 'Password and Confrim Password should match'
  }
  return errors
}
 
function ValidateEmail(mail)
{
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
  {
    return (true)
  }
  return (false)
}